import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'

// PCI DSS 6.4.3 / 11.6.1: keep the assistant off pages that collect payment or donor details.
const DONOR_FACING_ROUTES = ['CampaignDonate', 'DonationVerification', 'CampaignLead']

// Shared so the sidebar's Help items can open the widgets mounted in App.vue.
const assistantOpen = ref(false)
const bugReportOpen = ref(false)
const sidebarLayouts = ref(0)

export function useHelpWidgets() {
  const store = useStore()
  const route = useRoute()

  // Same audience as the API: canvassing org admins / field directors and Givaroo staff.
  const canUseAssistant = computed(
    () =>
      store.getters.isLoggedIn &&
      !DONOR_FACING_ROUTES.includes(route?.name) &&
      (store.getters.isCanvassingOrgAdmin ||
        store.getters.isCanvassingOrgFieldDirector ||
        store.getters.isGivarooStaff),
  )

  // Fundraisers report through their Director first. Donors arriving from a QR scan are
  // unattended (matches how CampaignDonate hides the nav menu for them).
  const canReportProblem = computed(() => !store.getters.isFundraiser && !route?.query?.from_qrcode)

  // Pages with the dashboard sidebar open the widgets from its Help items instead of
  // floating buttons, which kept covering page content at some screen sizes.
  const hasSidebar = computed(() => sidebarLayouts.value > 0)

  return { assistantOpen, bugReportOpen, canUseAssistant, canReportProblem, hasSidebar }
}

// Called by the dashboard layout so the floating buttons hide while its sidebar is shown.
export function useSidebarHelpLauncher() {
  onMounted(() => {
    sidebarLayouts.value++
  })
  onBeforeUnmount(() => {
    sidebarLayouts.value--
  })
}
